import { render, staticRenderFns } from "./page.vue?vue&type=template&id=4f3dbe73&scoped=true&"
import script from "./page.vue?vue&type=script&lang=ts&"
export * from "./page.vue?vue&type=script&lang=ts&"
import style0 from "./page.vue?vue&type=style&index=0&id=4f3dbe73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3dbe73",
  null
  
)

export default component.exports